import React from "react";
import { useTranslation } from "react-i18next";
import { LoginPagesLayout } from "@features/login/LoginPagesLayout";
import { ShowcasePageTitle } from "@components";
import { ResetPasswordPageForm } from "./ResetPasswordPageForm";

export const ResetPasswordPage = () => {
  const { t } = useTranslation();

  return (
    <LoginPagesLayout>
      <ShowcasePageTitle
        title={t("resetPasswordPage.header.title")}
        subtitle={t("resetPasswordPage.header.subtitle")}
      />

      <ResetPasswordPageForm />
    </LoginPagesLayout>
  );
};
